import { ShowWrapper } from "@/layouts/ShowWrapper";
import { VersionActions, VersionDetailTabs } from "@/resources-def/versionSettings-comp";

export const ShowVersion = () => {
  return (
    <ShowWrapper
      actions={<VersionActions />}
      details={VersionDetailTabs()}
    />
  );
};